import * as React from 'react';

export interface Props {
  isOnline?: boolean;
}

export const OfflineSection: React.StatelessComponent<Props> = (props) => {
  return (
    props.isOnline === false ? (
      <>
        {props.children}
      </>
    ) : null
  );
};


// WEBPACK FOOTER //
// ./src/components/offline-section/component.tsx